__turbopack_context__.v({
  "dialogLink": "DilWBq_dialogLink",
});
